import { NJInlineMessage, NJText } from '@engie-group/fluid-design-system-react';
import type { WeatherStation } from './types';

export function StationNotice({ station }: { station: WeatherStation }) {
  return (
    <NJInlineMessage variant="information" scale="sm">
      <NJText scale="sm">{station.assignment === 'simulated-service-area'
        ? 'Station de démonstration : position approximative, contour et rattachement communal fictifs, sans couverture météo réelle. DJU, DJClim et historique simulés ; aucune mesure source.'
        : `Nom et position : point source. WSS : ${station.wssId ?? 'identifiant inconnu'}. Rattachement communal déduit des zones exportées. DJU, DJClim et historique simulés ; aucune mesure source.`}</NJText>
    </NJInlineMessage>
  );
}
